export default __webpack_public_path__ + "8f35a74e575fd8926471b96eff301535.jpg";